import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  box-sizing: border-box;
  ${({ disabled }) => disabled && "pointer-events: none; opacity: 0.4"};
`;
